/**
* Components are lazy-loaded - See "Grouping Components in the Same Chunk"
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/
/* eslint-disable global-require */
// const userportalDemo = r => require.ensure([], () => r(require('./components/userportaldemo')), 'userportal'); 
const userportal = r => require.ensure([], () => r(require('./components/userportal')), 'userportal'); 
// const Peers = r => require.ensure([], () => r(require('./components/peers')), 'userportal');
// const Test = r => require.ensure([], () => r(require('./components/test')), 'userportal');
// const TeamPortal = r => require.ensure([], () => r(require('./components/teamportal')), 'userportal');
const Enduserportal = r => require.ensure([], () => r(require('./components/enduserportal')), 'userportal'); 
const Enduserportal2 = r => require.ensure([], () => r(require('./components/enduserportal_ar')), 'userportal');  
export default [
    
    {
        name: 'userportal',
        path: '/userportal/:id',
        meta: { requiresAuth: false },
        component: userportal,
    },
    {
        name: 'Enduserportal',
        path: '/userportal-v2/en/:id',
        meta: { requiresAuth: false },
        component: Enduserportal,
    },
    {
        name: 'Enduserportal2',
        path: '/userportal-v2/ar/:id',
        meta: { requiresAuth: false },
        component: Enduserportal2,
    },
    // {
    //     name: 'teamportal',
    //     path: '/teamportal',
    //     component: TeamPortal,
    // },
    // {
    //     name: 'peers',
    //     path: '/peers',
    //     component: Peers,
    // },
    //  {
    //     name: 'test',
    //     path: '/test',
    //     component: Test,
    // },
]



// WEBPACK FOOTER //
// ./src/app/userportal/routes.js